import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-4">
      <div className="max-w-md space-y-3 border border-border bg-bg-elevated p-6 text-center">
        <p className="text-6xl font-bold text-primary">404</p>
        <h1 className="text-xl font-bold">Página no encontrada</h1>
        <p className="text-sm text-text-secondary">
          La ruta que buscas no existe o fue movida.
        </p>
        <Button onClick={() => navigate('/', { replace: true })}>Volver al inicio</Button>
      </div>
    </div>
  );
}